<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">filter_list</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.logsHistory' | translate}}</span>
      </div>
      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="0.5 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg" fusePerfectScrollbar>
      <!-- / SEARCH -->
      @if (dataSource) {
        <mat-table matSort [dataSource]="dataSource" class="products-table"
          (matSortChange)="sortData($event)">
          <ng-container matColumnDef="user">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'main.frontuser' | translate}} </mat-header-cell >
            <mat-cell *matCellDef="let element"> {{element?.firstName}} {{element?.lastName}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="login">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'main.login' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element?.login | date: 'EEE, d. MMMM HH:mm'}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="logout">
            <mat-header-cell *matHeaderCellDef> {{'main.logOut' | translate}} </mat-header-cell>
            <mat-cell  *matCellDef="let element"> {{element?.logout | date: 'EEE, d. MMMM HH:mm'}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="time">
            <mat-header-cell *matHeaderCellDef> {{'budget.totalTime' | translate}} </mat-header-cell>
            <mat-cell  *matCellDef="let element" > {{element?.time}} </mat-cell>
          </ng-container>
          <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      }
    <!--      </div>-->
    <mat-paginator
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20]"
      [pageIndex]="pageIndex"
      [length]="totalCount"
      (page)="changePageEmitter($event)"
    showFirstLastButtons></mat-paginator>
  </div>
  <!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
